import { Header } from "../../../../src/components/common/header";
import { ReferralTerms } from "../../../../src/components/referral-terms";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  Header,
  ReferralTerms,
  Footer,
  React
};